import { render, staticRenderFns } from "./SpkDetail.vue?vue&type=template&id=91eebbd4&"
import script from "./SpkDetail.vue?vue&type=script&lang=js&"
export * from "./SpkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports